import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* createOrUpdateCoupon() {
    yield takeEvery(actions.CREATE_OR_UPDATE_COUPON_REQUESTED, function* (action) {
        try {
            const coupon = yield call(actions.createOrUpdateCoupon, action.payload);
            yield put({ type: actions.CREATE_OR_UPDATE_COUPON_SUCCEEDED, coupon });
        } catch (error) {
            yield put({ type: actions.CREATE_OR_UPDATE_COUPON_FAILED, error: error.response.data.message });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(createOrUpdateCoupon)
    ]);
}
